class Accordeon {
    constructor(el) {
        this.$container = $(el);
        this.$content = this.$container.find('.js-accordeon-content');
        this.$toggler = this.$container.find('.js-accordeon-toggler');

        this.bind();
    }

    bind() {
        this.$toggler.on('click', () => {
            this.toggle();
        });

        this.$toggler.on('keydown', (e) => {
            // Пробел и Enter
            if (e.keyCode == 32 || e.keyCode == 13) {
                e.preventDefault();
                this.toggle();
            }
        });
    }

    toggle() {
        if (this.$container.is('._active')) {
            this.$container.removeClass('_active');
            this.$content.clearQueue().slideUp(300);
        } else {
            this.$container.addClass('_active');
            this.$content.clearQueue().slideDown(300);
        }
    }
}

$('.js-accordeon-item').each(function() {
    new Accordeon(this);
});



// WEBPACK FOOTER //
// ./_src/js/modules/Accordeon.js